<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "business/guardians",
    cardSetLink: "business/guardians",
    item: null,
    fields: [
      {
        key: "phone",
        label: "Номер телефона",
        type: "field",
        textType: "text",
        readonly: true,
      },
      {
            col:'col-12 col-md-6',
            key: "last_name",
            label: "Фамилия",
            type: "field",
            textType: "text",
      },
      {
        col:'col-12 col-md-6',
        key: "first_name",
        label: "Имя",
        type: "field",
        textType: "text",
        readonly: false,
      },
      {
        col:'col-12 col-md-6',
        key: "father_name",
        label: "Отчество",
        type: "field",
        textType: "text",
        readonly: false,
      },
      //   {
      //       col:'col-12 col-md-6',
      //       key: "birthday",
      //       label: "Дата рождения",
      //       textType: "date",
      //       type: "field",
      // },
      ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
